import { useStylesFactory } from "aesthetic-react";
import Core from "../../src";

export const aesthetic = Core.aesthetic;
export default useStylesFactory(Core.aesthetic);
